module.exports = __webpack_public_path__ + "img/timestamp-original.a8bcabb5.webp";